

/****************************************************************************

  Generated by const.tst - please don't make any changes in this file

****************************************************************************/


    /** Generated from NBWebCGA.Web.StepStateCodes **/
	export const StepStateCodes = { 
		error: 'E',
		toValidate: 'TV',
		valid: 'V',
		dOverlap: 'MI',
    
	}

    /** Generated from NBWebCGA.Web.VisualActions **/
	export const VisualActions = { 
		readonly: 'R',
		disable: 'D',
		hide: 'H',
    
	}


